import { API, buildQueryParams, get } from "api";

interface CustomFrameProps {
    key: string; // ftl filename
    materialSpecId: number;
    adMaterialId?: number;
}

export interface CustomFrameResponse {
    url: string;
}

export const getCustomFrameReq = async (
    headers: HeadersInit,
    { key, materialSpecId, adMaterialId }: CustomFrameProps
) => {
    const { parsedBody } = await get<CustomFrameResponse>(
        `${API.baseApiUrl}/customframe?${buildQueryParams({ key, matspec: materialSpecId, admaterial: adMaterialId })}`,
        {
            headers,
        }
    );

    return parsedBody;
};
